/**
 * 认证模块（OFBiz 新接口）
 * ------------------------------------------------------------------
 * 后端登录路径为 /itoss/control/json/login（不带 auth 前缀，后端实测确认）。
 * OpenAPI 文档里写的 auth/login 是旧值，以实际为准。
 *
 * 鉴权方式：登录成功后由后端写 JSESSIONID Cookie，浏览器自动携带，
 * 不再需要把 token 拼到 URL 上。
 */
import { ofbiz } from './http';

/**
 * 登录
 * @param {string} username 用户名
 * @param {string} password 密码（明文，后端 SHA 哈希校验）
 * @returns {Promise<object>} 后端 data（通常含 userLoginId / 用户基本信息）
 *
 * 注意：后端登录接口要求 application/x-www-form-urlencoded。
 */
export function login(username, password) {
  return ofbiz.postForm('login', { username, password });
}

/**
 * 获取当前登录用户信息（替代旧 queryGetUserInfo / getUserInfo）
 * @returns {Promise<object>} 用户信息 + 权限
 */
export function authMe() {
  return ofbiz.post('authMe');
}

/**
 * 退出登录
 * @returns {Promise<object>}
 */
export function logout() {
  return ofbiz.post('logout');
}

/**
 * 个人修改密码（旧 changePassword）
 * @param {string} oldPassword 旧密码
 * @param {string} newPassword 新密码
 * @returns {Promise<object>}
 */
export function userChangePassword(oldPassword, newPassword) {
  // 该接口要求表单提交
  return ofbiz.postForm('userChangePassword', { oldPassword, newPassword });
}
